// extracted by mini-css-extract-plugin
module.exports = {"blockFlex":"_1VJagEL4","inputsContainer":"_3c7Fi9_Z","scrollDiv":"Gv9Bzse7","firstInput":"v_6keVIK","nameInputs":"_32iHHs6K","autoSaving":"vU9lBKBX","autoSaved":"_17bCyRa3","saveContent":"pzuF2uxQ","inputContainer":"HE4ma1hu","input":"_20GuQXvl","emailContent":"_1ycs6br-"};
    if(module.hot) {
      // 1754514988440
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  